/* cl-swipe: nota do operador — todo carrossel funciona por SETA, ARRASTE DE MOUSE e TOQUE,
   no desktop e no mobile. As secoes copiadas do concorrente usam trilhos nativos
   (overflow-x:auto + scroll-snap): o toque ja funciona; aqui entram o arraste com mouse e as
   setas (so onde a secao nao tem setas proprias). Reavalia no resize: setas so aparecem
   quando o trilho de fato rola naquela largura. */
(function(){
  if (window.__clSwipe) return; window.__clSwipe = true;
  var ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var OWN_NAV = /(^|[\s_-])(nav|prev|next|arrow|left|right)([\s_-]|$)|slider-button|swiper-button|splide__arrow/i;

  function scrollers(root){
    var out = [];
    root.querySelectorAll('*').forEach(function(el){
      if (el.__clSw || el.closest('#ClCart, .cl-no-swipe')) return;
      var cs = getComputedStyle(el);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.children.length > 1) out.push(el);
    });
    return out;
  }
  function step(el){
    var c = el.children[0], g = parseFloat(getComputedStyle(el).columnGap) || parseFloat(getComputedStyle(el).gap) || 0;
    return c ? c.getBoundingClientRect().width + g : el.clientWidth * .8;
  }
  function hasOwnNav(el, sec){
    var btns = sec.querySelectorAll('button, [role="button"], a');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i]; if (el.contains(b) || b.classList.contains('cl-sw-arrow')) continue;
      if (!b.offsetParent || getComputedStyle(b).visibility === 'hidden') continue;   /* seta propria escondida neste viewport */
      var c = (b.getAttribute('class') || '') + ' ' + (b.getAttribute('aria-label') || '');
      if (OWN_NAV.test(c) && /prev|next|left|right|arrow|nav/i.test(c)) return true;
    }
    return false;
  }
  function drag(el){
    var down = false, moved = false, sx = 0, sl = 0, snap = '';
    el.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = el.scrollLeft;
      snap = el.style.scrollSnapType; el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto';
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) { moved = true; el.classList.add('cl-sw-dragging'); }
      if (moved) { el.scrollLeft = sl - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function(){
      if (!down) return; down = false; el.classList.remove('cl-sw-dragging');
      el.style.scrollBehavior = '';
      if (moved) {
        var s = step(el), target = Math.round(el.scrollLeft / s) * s;
        el.scrollTo({left: target, behavior: 'smooth'});
        setTimeout(function(){ el.style.scrollSnapType = snap; }, 400);
      } else el.style.scrollSnapType = snap;
    });
    el.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }
  function arrows(el){
    var host = el.parentElement; if (!host) return null;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var p = document.createElement('button'), n = document.createElement('button');
    p.type = n.type = 'button';
    p.className = 'cl-sw-arrow cl-sw-prev'; n.className = 'cl-sw-arrow cl-sw-next';
    p.setAttribute('aria-label', 'Previous slide'); n.setAttribute('aria-label', 'Next slide');
    p.innerHTML = n.innerHTML = ARROW;
    p.addEventListener('click', function(){ el.scrollBy({left: -step(el), behavior: 'smooth'}); });
    n.addEventListener('click', function(){ el.scrollBy({left: step(el), behavior: 'smooth'}); });
    host.appendChild(p); host.appendChild(n);
    return [p, n];
  }
  function update(el){
    var can = el.scrollWidth > el.clientWidth + 4;
    el.classList.toggle('cl-sw-on', can);
    if (el.__clArrows) {
      el.__clArrows.forEach(function(a){ a.hidden = !can; });
      el.__clArrows[0].disabled = el.scrollLeft <= 2;
      el.__clArrows[1].disabled = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
    }
  }
  function scan(){
    document.querySelectorAll('[class*="cl-sec-"], .cl-swipe').forEach(function(sec){
      scrollers(sec).forEach(function(el){
        el.__clSw = true;
        drag(el);
        if (!hasOwnNav(el, sec)) el.__clArrows = arrows(el);
        else el.__clSec = sec;
        el.addEventListener('scroll', function(){ update(el); }, {passive: true});
        update(el);
      });
    });
    document.querySelectorAll('.cl-sw-on, [class*="cl-sec-"] *').forEach(function(el){ if (el.__clSw) update(el); });
  }
  /* Swiper/slick: arraste e toque ja vem da lib; so faltam setas quando a config dele nao tem */
  function libArrows(){
    document.querySelectorAll('.swiper').forEach(function(el){
      var sw = el.swiper; if (!sw || el.__clArr || el.closest('#ClCart')) return;
      var host = el.parentElement, sec = el.closest('[class*="cl-sec-"], product-info, .shopify-section') || host;
      var hasNav = sw.params && sw.params.navigation && (sw.params.navigation.nextEl || sw.params.navigation.prevEl);
      if (hasNav || hasOwnNav(el, sec)) { el.__clArr = true; return; }
      if (sw.params) { sw.params.simulateTouch = true; sw.params.grabCursor = true; }
      el.__clArr = true;
      var a = arrows(el); if (!a) return;
      a[0].onclick = function(e){ e.stopImmediatePropagation(); sw.slidePrev(); };
      a[1].onclick = function(e){ e.stopImmediatePropagation(); sw.slideNext(); };
      function st(){ var many = sw.slides && sw.slides.length > 1 && !(sw.isBeginning && sw.isEnd);
        a.forEach(function(b){ b.hidden = !many; });
        if (!sw.params.loop) { a[0].disabled = sw.isBeginning; a[1].disabled = sw.isEnd; } }
      sw.on && sw.on('slideChange resize', st); st();
    });
    if (window.jQuery) window.jQuery('.slick-initialized').each(function(){
      var el = this; if (el.__clArr) return; el.__clArr = true;
      if (el.querySelector('.slick-arrow') || hasOwnNav(el, el.closest('[class*="cl-sec-"]') || el.parentElement)) return;
      /* slick nao rola quando cabe tudo (slideCount <= slidesToShow): sem setas, como no concorrente */
      try { var sk = window.jQuery(el).slick('getSlick'); if (sk && sk.slideCount <= sk.options.slidesToShow) { el.__clArr = false; return; } } catch (e) {}
      var a = arrows(el); if (!a) return;
      a[0].onclick = function(){ window.jQuery(el).slick('slickPrev'); };
      a[1].onclick = function(){ window.jQuery(el).slick('slickNext'); };
    });
  }
  function boot(){ scan(); libArrows(); setTimeout(function(){ scan(); libArrows(); }, 1200); setTimeout(function(){ scan(); libArrows(); }, 4000); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(function(){
    document.querySelectorAll('*').forEach(function(el){ if (el.__clSw) update(el); }); }, 150); });
})();
